import type { PanelItem } from '@vedalib/editor/lib/elements'
import { createContext } from 'use-context-selector'

import { NOOP } from 'constants/commonConstans'
import { PREVIEW_MODE } from 'services/Store/Project/constants'
import type { IBlockMode } from 'services/Store/Project/types'

export interface ISliderContextProps {
  goToSlide: (slide: number) => void
  nextSlide: () => void
  prevSlide: () => void
  slideIndex: number
  items: PanelItem[]
  mode: IBlockMode
  leftArrowNoLoop: boolean
  rightArrowNoLoop: boolean
  includeSlide?: {
    first: boolean
    last: boolean
  }
}

const SliderContext = createContext<ISliderContextProps>({
  goToSlide: NOOP,
  nextSlide: NOOP,
  prevSlide: NOOP,
  slideIndex: 0,
  items: [],
  mode: PREVIEW_MODE,
  leftArrowNoLoop: true,
  rightArrowNoLoop: true,
  includeSlide: {
    first: true,
    last: true,
  },
})

export default SliderContext
